import MDBox from '../../../../components/MDComponents/MDBox'
import Spinner from '../../../../components/Spinner'
import { useState, useMemo } from 'react'
import CustomTour from '../../../../components/CustomTour'
import SubjectOption from './subject-option'
import InlineSelect from 'components/InlineSelect'
import { MenuItem } from '@mui/material'
import Button from '../../../../components/Button'

const ALL_FACULTIES_FILTER = 'Toate facultățile'

const PickSubject = ({
  startNewSubject,
  subjectOptions,
  dropdownValue,
  isLoadingSubjectByCode,
}) => {
  const [subjectCode, setSubjectCode] = useState('')
  const [facultyFilter, setFacultyFilter] = useState(ALL_FACULTIES_FILTER)

  const facultyFilterOptions = useMemo(() => {
    const options = new Set()

    options.add(ALL_FACULTIES_FILTER)
    for (const subjectOption of subjectOptions) {
      if (subjectOption.value === -1) {
        continue
      }
      subjectOption.faculties.forEach(faculty => options.add(faculty))
    }

    return [...options]
  }, [subjectOptions])

  const filteredSubjectOptions = useMemo(() => {
    return subjectOptions.filter(
      option =>
        option.value !== -1 &&
        (facultyFilter === ALL_FACULTIES_FILTER ||
          option.faculties.includes(facultyFilter)),
    )
  }, [facultyFilter, subjectOptions])

  return (
    <>
      {subjectOptions !== undefined && dropdownValue !== undefined ? (
        <MDBox className="flex flex-col items-center !text-over-secondary-background !bg-secondary-background lg:items-center w-full mx-auto rounded">
          <div className="py-3 !w-full pick-subject-container">
            <div className="flex sm:flex-row flex-col items-center justify-between w-full">
              <p className="text-lg sm:text-left text-center">
                Generează o simulare nouă
              </p>
              <div className="flex max-w-60">
                <input
                  type="text"
                  name="voucher"
                  className="rounded-[4px] pl-1 max-w-40 text-over-primary-background border hover:border-primary border-brd-primary bg-secondary-background w-full min-h-[44px] text-sm"
                  placeholder="Cod simulare"
                  onChange={event => {
                    setSubjectCode(event.target.value)
                  }}
                  value={subjectCode}
                />
                {subjectCode?.length !== 0 ? (
                  <Button
                    isLoading={isLoadingSubjectByCode}
                    onClick={async () => startNewSubject(-2, subjectCode)}
                    className="bg-btn-primary h-10 w-24 ml-5"
                  >
                    Rezolvă
                  </Button>
                ) : null}
              </div>
            </div>

            <SubjectOption
              option={subjectOptions.find(option => option.value === -1)}
              startNewSubject={startNewSubject}
              subjectOptions={subjectOptions}
              facultyFilter={facultyFilter}
            />
            <div className="my-6 text-over-secondary-background text-center flex flex-col items-center justify-center gap-[10px]">
              <p className="text-lg">
                sau <br />
                Rezolvă un subiect din anii anteriori!
              </p>
              {facultyFilterOptions.length > 2 ? (
                <InlineSelect
                  value={facultyFilter}
                  onChange={event => setFacultyFilter(event.target.value)}
                >
                  {facultyFilterOptions.map(faculty => (
                    <MenuItem
                      key={`faculty-filter-option-${faculty}`}
                      className="text-over-primary-background"
                      value={faculty}
                    >
                      {faculty}
                    </MenuItem>
                  ))}
                </InlineSelect>
              ) : null}
            </div>
            <div className="grid grid-cols-1 justify-between items-center">
              {filteredSubjectOptions.map((option, index) => (
                <SubjectOption
                  key={'subject-option-' + index}
                  option={option}
                  startNewSubject={startNewSubject}
                  subjectOptions={subjectOptions}
                  facultyFilter={facultyFilter}
                  buttonId={index === 0 ? 'start-new-subject' : ''}
                />
              ))}
            </div>
          </div>
        </MDBox>
      ) : (
        <Spinner />
      )}
      <CustomTour
        isOpen={subjectOptions !== undefined && dropdownValue !== undefined}
      />
    </>
  )
}

export default PickSubject
